import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const trinoDatasetMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.trino.datasetType,
    supportLinkedServiceTypes: [adfModelTypeMap.trino.linkedServiceType],
    displayName: stringResources.Trino_FormalName,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-Trino'
    },
    isSource: true,
    isSink: false,
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Database']
};
